import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  // FastAPI object-shaped detail from our own HTTPException raises
  // (e.g. `{code, path, message, ...}`) — surface the human message
  // instead of the raw object (which previously rendered as
  // "[object Object]" through String(detail)).
  if (detail && typeof detail === "object" && typeof detail.message === "string") {
    return detail.code
      ? `${detail.message} (${detail.code})`
      : detail.message;
  }
  return String(detail);
}

export default api;
